import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

// If you want to add custom styles, you can use the `sx` prop.
const customTooltip = {
    color: "white",
    letterSpacing: "1px",
    backgroundColor: "#6c757d",
    opacity: 1,
    fontSize: "11px",
    fontWeight: 400,
};

const InfoPopup = ({ title, children }) => (
    <Tooltip title={title} placement="right" sx={customTooltip} arrow>
        {children}
    </Tooltip>
);

const lookupConstant = [
    { label: "Single Operator", text: "1" },
    { label: "Small Operator", text: "2-9" },
    { label: "Medium Operator", text: "10-19" },
    { label: "Large Operator", text: "20+" },
    { label: "REIT", text: "Include: Equity LifeStyle Properties, Inc. (ELS) and Sun Communities, Inc. (SUI)." },
]

const LookupComponent = (label , isDisplay = false) =>{
    
    if(!isDisplay){
        return <div className="sub-heading">  {label} </div>
    }

    return  (
    <div className="sub-heading">
        {label}
        <InfoPopup
            title={
                <>
                    <div className="operator-tooltip-des">
                        <strong>Facility Size</strong>
                        <table className="table-des-siz">
                            <tbody>
                                {lookupConstant.map((entry) => {
                                    return (
                                        <tr key={entry.label}>
                                            <td>{entry.label}</td>
                                            <td>{entry.text}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        >
            <span className='summary-kd-info'>
                <FontAwesomeIcon icon={faInfoCircle} />
            </span>
        </InfoPopup>
    </div>

    );
    
};
export default LookupComponent;